module.exports = __webpack_public_path__ + "svg/cogwheel_hover.b3a80292b96b0165452ac782fe4a5f8a.svg";